import _Cookies from 'js-cookie';

export enum CookieKey {
  _ga = '_ga',
  __utmz = '__utmz',
  _ym_uid = '_ym_uid',
  HIDE_EMAIL_BANNER = 'HIDE_EMAIL_BANNER',
  HIDE_MOBILE_BANNER = 'HIDE_MOBILE_BANNER',
  HIDE_POPUP_BEST_OFFERS = 'HIDE_POPUP_BEST_OFFERS',
  HIDE_SHARE_BANNER = 'HIDE_SHARE_BANNER',
  HIDE_EXIT_INTENT_POPUP = 'HIDE_EXIT_INTENT_POPUP',
  _SL_ = '_SL_',
  clid = 'clid',
  USER_ID = 'userId',
  _PN_ = '_PN_',
  aff_click_id = 'aff_click_id',
  aff_id = 'aff_id',
  amount = 'amount',
  term = 'term',
  mindboxUUid = 'mindboxDeviceUUID',
  MFO_VITRINA_CRM_VISITED = '_sr_mfc7k2v',
  MFO_VITRINA_CRM_CLICKED = '_sr_mfc7k2c',
}

export type CookieModel = Partial<Record<CookieKey, string>>;

export const Cookie = _Cookies;
